// extracted by mini-css-extract-plugin
export var container = "_76-0";
export var infoButton = "_76-1";
export var label = "_76-3";
export var labelExpanded = "_76-4";
export var price = "_76-5";
export var priceExpanded = "_76-6";
export var title = "_76-2";